<div class="row fill-screen">
  <app-skills (skillAddedEvent)="onSkillAdded($event)"
              (skillLevelChangedEvent)="onSkillLevelChanged($event)"
              (skillRemovedEvent)="onSkillRemoved($event)"
              (lavishUpdatedEvent)="onLavishUpdated($event)"
              (tableAddedEvent)="onTableAdded($event)"
              (tableRemovedEvent)="onTableRemoved($event)"
              (upgradeChangedEvent)="onUpgradeChanged($event)"
              [imageBaseUrl]="imageBaseUrl"
              [imageTemplateUrl]="imageTemplateUrl"
              class="col bg-dark-elevated-2 col-border bottom-padding">
  </app-skills>
  <app-ingredients (ingredientPriceChangedEvent)="onIngredientPriceChanged($event)"
                   (laborCostChangedEvent)="onLaborCostChanged($event)"
                   (profitPercentChangedEvent)="onProfitPercentChanged($event)"
                   [imageBaseUrl]="imageBaseUrl"
                   [imageTemplateUrl]="imageTemplateUrl"
                   (rebatePercentChangedEvent)="onRebatePercentChanged($event)"
                   (taxPercentChangedEvent)="onTaxPercentChanged($event)"
                   class="col bg-dark-elevated-2 col-border bottom-padding">
  </app-ingredients>
  <app-outputs (itemRemovedEvent)="onItemRemoved($event)"
               (recipeAddedEvent)="onRecipeAdded($event)"
               (subRecipeRemovedEvent)="onSubRecipeRemoved($event)"
               (recipeModalOpenedEvent)="onRecipeModalOpened($event)"
               [imageBaseUrl]="imageBaseUrl"
               [imageTemplateUrl]="imageTemplateUrl"
               class="col-5 bg-dark-elevated-2 col-border bottom-padding">
  </app-outputs>
</div>
